<div class="expandable-cards-group" *rxLet="vm$; let vm">
  <app-section-header-with-action [sectionTitle]="sectionTitle"
                                  [label]="vm.panelToggleButtonLabel"
                                  (action$)="toggleAll()"></app-section-header-with-action>
  <ng-content></ng-content>
</div>
